import styled from 'styled-components';
import { media } from '@bitcoin-portal/bitcoincom-pkg-theme';
import ContentBlock from '@bitcoin-portal/bitcoincom-pkg-components/dist/ContentBlock';
import Image from '@bitcoin-portal/bitcoincom-pkg-components/dist/Image';

export const StyledContentBlock = styled(ContentBlock)`
  ${media.md`
    margin-bottom: 100px;
  `}
`;

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: visible;
  width: 100%;

  & > span {
    display: inline-flex !important;
    justify-content: center;
  }

  ${media.md`
    justify-content: flex-end;
    max-height: 280px;
  `}

  ${media.xl`
    max-height: 450px;
  `}
`;

export const StyledImage = styled(Image)`
  filter: drop-shadow(0px 20px 51px rgba(10, 193, 142, 0.6));
  margin-bottom: 40px;
  width: 231px;
  height: 271px;

  ${media.md`
    filter: drop-shadow(0px 28px 71px rgba(10, 193, 142, 0.6));
    margin-bottom: 0;
    width: 323px;
    height: 379px;
  `}

  ${media.xl`
    filter: drop-shadow(0px 44px 110px rgba(10, 193, 142, 0.6));
    width: 549px;
    height: 644px;
  `}
`;
